/* 
    This file manages the photography storage for the dealer photography app.
    It allows setting and getting the photos across different components. 
*/
import { openDB } from 'idb';

const DB_NAME = 'photo-gallery-db';
const STORE_NAME = 'photos';

export async function getDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { autoIncrement: true });
      }
    },
  });
}

export async function savePhoto(photoData) {
  const db = await getDB();
  return db.add(STORE_NAME, photoData);
}

export async function getPhoto(key) {
  const db = await getDB();
  return db.get(STORE_NAME, key);
}

export async function getAllPhotos() {
  const db = await getDB();
  return db.getAllKeys(STORE_NAME);
}

export async function deletePhoto(key) {
  const db = await getDB();
  return db.delete(STORE_NAME, key);
}